import React from 'react';
import { Route, RouteProps } from 'react-router-dom';
import { useAppSelector } from 'setup/redux/Hooks';
import { selectUser } from 'app/modules/auth';
import { AccessDenied } from 'app/modules/errors/components/AccessDenied';

interface WatanCompanyRouteProps extends RouteProps {
  component: React.ComponentType<any>;
}

export const WatanCompanyRoute: React.FC<WatanCompanyRouteProps> = ({ 
  component: Component, 
  ...rest 
}) => {
  const user = useAppSelector(selectUser);
  const isClusterLogic = 
    !!user?.companyId && !!user?.isWatanCompany;

  return (
    <Route
      {...rest}
      render={(props) =>
        isClusterLogic ? (
          <Component {...props} />
        ) : (
          <AccessDenied />
        )
      }
    />
  );
};